import React from 'react'
import PropTypes from 'prop-types'
import ClipIcon from './FileUploadIcon/ClipIcon'

class ListItem extends React.Component {
  render() {
    const { value, removeItem, index } = this.props
    // Generate a unique ID for the list item
    const itemId = `file-item-${index || value.replace(/\s+/g, '-').toLowerCase()}`

    return (
      <li id={itemId}>
        <div className="item-list">
          <div className="icon-container">
            <button
              type="button"
              className="close-icon-container"
              aria-label={`Remove file ${value}`}
              onClick={removeItem}
            >
              <svg
                className="closeIcon"
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M5.00008 6.41423L1.70718 9.70712L0.292969 8.29291L3.58586 5.00001L0.292969 1.70712L1.70718 0.292908L5.00008 3.5858L8.29297 0.292908L9.70718 1.70712L6.41429 5.00001L9.70718 8.29291L8.29297 9.70712L5.00008 6.41423Z"
                  fill="black"
                />
              </svg>
            </button>
            <ClipIcon aria-hidden="true" />
          </div>
          <div className="file-name">{value}</div>
        </div>
      </li>
    )
  }
}

ListItem.propTypes = {
  value: PropTypes.string.isRequired,
  removeItem: PropTypes.func.isRequired,
  index: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default ListItem
